export const escapeSquareBrackets = (selector) => {
    return selector.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
}
export const containsSquareBrackets = (str) => {
    return str.includes('[') || str.includes(']');
}

export const stripChars = (str, chars) => {
    if (!str || !chars || !Array.isArray(chars) || chars.length === 0) {
        return str; // Return original string if input is invalid
    }

    let start = 0;
    let end = str.length - 1;

    while (start <= end && chars.includes(str[start])) {
        start++;
    }

    while (end >= start && chars.includes(str[end])) {
        end--;
    }

    return str.substring(start, end + 1);
}

export const isNotStringOrEmptyString = (value) => {

    if(undefined === value || null === value) return true;

    if(typeof value !== 'string' && typeof value !== 'number') {
        return true;
    }

    return '' === value.toString().trim();

}

export function generateIdFromName(name) {
    if (typeof name !== 'string') {
        return ''; // Handle non-string inputs
    }

    return name
        .toLowerCase()
        .replace(/\W+/g, '-') // Replace non-word characters with '-'
        .replace(/^-+|-+$/g, ''); // Trim leading/trailing '-'
}

/**
 * Generates a text excerpt (snippet) from a string, stripping HTML markup first.
 *
 * @param {string} htmlString - The input string, potentially containing HTML.
 * @param {number} maxLength - The maximum desired length of the excerpt (in characters).
 * @returns {string} The final excerpt string, truncated and optionally appended with an ellipsis.
 */
export const generateExcerptClientSide = (htmlString, maxLength) => {
   if (!htmlString || typeof htmlString !== 'string') {
      return '';
   }
   
   // 1. Strip HTML Markup
   // Use a DOMParser (available in the browser/client-side) to safely strip HTML.
   try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      
      // Get the raw text content from the parsed document
      const rawText = doc.body.textContent || "";
      
      // 2. Normalize Whitespace (Optional but recommended)
      // Replace multiple spaces/newlines with a single space and trim.
      const cleanText = rawText.replace(/\s+/g, ' ').trim();
      
      // 3. Truncate and Append Ellipsis
      if (cleanText.length <= maxLength) {
         // If the content is short enough, return it as is.
         return cleanText;
      }
      
      // Truncate the string to the maximum length
      let excerpt = cleanText.substring(0, maxLength);
      
      // Optional: Find the last space before the truncation point to avoid cutting a word.
      const lastSpace = excerpt.lastIndexOf(' ');
      if (lastSpace !== -1) {
         excerpt = excerpt.substring(0, lastSpace);
      }
      
      // Append ellipsis
      return excerpt + '...';
      
   } catch (error) {
      console.error("Failed to parse HTML for excerpt generation:", error);
      return htmlString.substring(0, maxLength) + '...'; // Fallback
   }
};